import { ui_service_ip } from "./ip_details";
import { call_post_api, call_get_api, call_delete_api, call_update_api } from "./event_handling";
/**
 * Generic function to handle API calls based on the method type.
 * @param {string} method - The HTTP method (GET, POST, UPDATE, DELETE).
 * @param {string} endpoint - The endpoint for the API call.
 * @param {Object} params - The parameters or request body for the API call.
 * @returns {Object} - The result from the API call.
 */
async function handleApiCall(method, endpoint, params) {

    // Temp Fix for date issue in realtime monitoring
    let temp_params = {
        ...params,
        ...(params.start_date && {
            start_date: params.start_date.split(" ")[0]
        }),
        ...(params.end_date && {
            end_date: params.end_date.split(" ")[0]
        })
    };

    try {
        let result;
        switch (method.toUpperCase()) {
            case "GET":
                result = await call_get_api(ui_service_ip, endpoint, temp_params);
                break;

            case "POST":
                result = await call_post_api(ui_service_ip, endpoint, temp_params);
                break;

            case "PUT":
            case "UPDATE":
                result = await call_update_api(ui_service_ip, endpoint, params);
                break;

            case "DELETE":
                result = await call_delete_api(ui_service_ip, endpoint, temp_params);
                break;

            default:
                throw new Error(`Unsupported HTTP method: ${method}`);
        }

        return result; // Return the result from the API
    } catch (error) {
        console.error(`Error during ${method} request to ${endpoint}:`, error); // Log any errors
    }
}
/**
 * Function to fetch the latest environment list (GET example).
 * @param {Object} requestParams - The request parameters for the API call.
 * @returns {Object} - The result from the API call.
 */
export function getLatestEnvironmentList(requestParams) {
    return handleApiCall("GET", "get_environments_latest", requestParams);
}

/**
 * Function to fetch the watchlist (GET example).
 * @param {Object} requestParams - The request parameters for the API call.
 * @returns {Object} - The result from the API call.
 */
export function getWatchList(requestParams) {
    return handleApiCall("GET", "get-watchlist", requestParams);
}

/**
 * Function to fetch all environment integrations (GET example).
 * @param {Object} requestParams - The request parameters for the API call.
 * @returns {Object} - The result from the API call.
 */
export function getAllEnvironmentIntegrations(requestParams) {
    return handleApiCall("GET", "env/list-integrations", requestParams);
}

/**
 * Function to fetch metrics value from the real-time monitoring tree (GET example).
 * @param {Object} requestParams - The request parameters for the API call.
 * @returns {Object} - The result from the API call.
 */
export function getMetricsValue(requestParams) {
    
    return handleApiCall("GET", "monitor/rt_tree", requestParams);
}

/**
 * Function to fetch chart data for real-time monitoring (GET example).
 * @param {Object} requestParams - The request parameters for the API call.
 * @returns {Object} - The result from the API call.
 */
export function getChartData(requestParams) {
    return handleApiCall("GET", "monitor/realtime", requestParams);
}

/**
 * Function to fetch all metadata mappings (GET example).
 * @param {Object} requestParams - The request parameters for the API call.
 * @returns {Object} - The result from the API call.
 */
export function getAllMetaData(requestParams) {
    return handleApiCall("GET", "metadata_mapping", requestParams);
}

/**
 * Function to save data to the API (POST example).
 * @param {Object} requestBody - The request body for the API call.
 * @returns {Object} - The result from the API call.
 */
export function saveWatchList(requestBody) {
    return handleApiCall("POST", "save-watchlist", requestBody);
}

/**
 * Function to delete data from the API (DELETE example).
 * @param {Object} requestParams - The request parameters for the API call.
 * @returns {Object} - The result from the API call.
 */
export function deleteWatchList(requestParams) {
    return handleApiCall("DELETE", "delete-watchlist", requestParams);
}

/**
 * Function to edit the watchlist (GET example).
 * @param {Object} requestParams - The request parameters for the API call.
 * @returns {Object} - The result from the API call.
 */
export function getEditWatchList(requestParams) {
    return handleApiCall("GET", "edit-watchlist", requestParams);
}

/**
 * Function to update data in the API (PUT/UPDATE example).
 * @param {Object} requestBody - The request body for the API call.
 * @returns {Object} - The result from the API call.
 */
export function updateWatchList(requestBody) {
    return handleApiCall("UPDATE", "edit-watchlist", requestBody);
}

/**
 * Function to delete data from the API (DELETE example).
 * @param {Object} requestParams - The request parameters for the API call.
 * @returns {Object} - The result from the API call.
 */
export function deleteUserTracking(requestParams) {
    return handleApiCall("DELETE", "user_tracking", requestParams);
}

/**
 * Function to add data from the API (POST example).
 * @param {Object} requestParams - The request parameters for the API call.
 * @returns {Object} - The result from the API call.
 */
export function addUserTracking(requestParams) {
    return handleApiCall("POST", "user_tracking", requestParams);
}

/**
 * Function to add data from the API (POST example).
 * @param {Object} requestParams - The request parameters for the API call.
 * @returns {Object} - The result from the API call.
 */
export function getIncidents(requestParams) {
    return handleApiCall("GET", "incidents", requestParams);
}


/**
 * Function to add data from the API (POST example).
 * @param {Object} requestParams - The request parameters for the API call.
 * @returns {Object} - The result from the API call.
 */
export function getWebSocketUrl(requestParams) {
    return handleApiCall("GET", "get_ws_string", requestParams);
}

export function getMetricsAggregation(requestParams) {
    return handleApiCall("GET", "monitor/realtime/aggregation", requestParams);
}

export function getProgressInfo(requestParams){
    return handleApiCall("GET", "dataset_progress_info", requestParams);
}
export function getIntegration(requestParams){
    return handleApiCall("GET", "integrations", requestParams);
}
export function getPipelineIntegration(requestParams){
    return handleApiCall("GET", "pipelineintegrations", requestParams);
}

export function getPipeline(requestParams){
    return handleApiCall("GET", "pipeline/realtime", requestParams);
}

export function getPipelineJobInfo(requestParams){
    return handleApiCall("GET", "realtime/pipeline_info", requestParams);
}

export function getWindirectDeployment(requestParams){
    return handleApiCall("GET", "get_rtd_deployment_details", requestParams);
    //return {'code': 200, 'message': 'Successfully fetched', 'data': {'created_time': '2024-09-04', 'rtd_deployment_date': '2025-04-10'}}
}

export function getLineageData(requestParams){
//     return {
//     "code": 200,
//     "lineage_data": {
//         "datasets": {
//             "raw_data_ingestion_dag": []
//         },
//         "is_error": false,
//         "links": [
//             {
//                 "destination": "data_transformation_pipeline",
//                 "source": "raw_data_ingestion_dag"
//             },
//             {
//                 "destination": "pipeline_finalization_dag",
//                 "source": "business_reporting_workflow"
//             },
//             {
//                 "destination": "pipeline_finalization_dag",
//                 "source": "data_transformation_pipeline"
//             },
//             {
//                 "destination": "business_reporting_workflow",
//                 "source": "raw_data_ingestion_dag"
//             }
//         ],
//         "pipeline_id": 343,
//         "pipeline_name": "raw_data_ingestion_dag",
//         "pipeline_run_id": 2188,
//         "pipeline_run_name": "scheduled__2026-01-06T12:40:00+00:00",
//         "tasks": {
//             "raw_data_ingestion_dag": [
//                 {
//                     "affected_datasets": [],
//                     "affected_jobs": [],
//                     "status": "Succeeded",
//                     "task_id": 7721,
//                     "task_name": "extract_data_task"
//                 },
//                 {
//                     "affected_datasets": [],
//                     "affected_jobs": [],
//                     "status": "Succeeded",
//                     "task_id": 7722,
//                     "task_name": "clean_data_task"
//                 }
//             ]
//         }
//     },
//     "message": "Successfully fetched"
// }
    return handleApiCall("GET", "lineage_data", requestParams);
}

export function getPipelineMetadata(requestParams){
    return handleApiCall("GET", "pipeline_mapping", requestParams);
}


export function pipelineRunInfo(requestParams){
    return handleApiCall("GET", "realtime/runs_info", requestParams);
}

export function pipelineStagesInfo(requestParams){
    return handleApiCall("GET", "realtime/stages_info", requestParams);
}

export function pipelineDetailsStagesInfo(requestParams){
//   return {
//   "code": 200,
//   "message": "Successfully fetched",
//   "data": {
//     "stage_data": {
//       "stage_id": 13487,
//       "stage_name": "wait_for_ingestion_pipeline",
//       "dag_id": "data_transformation_pipeline",
//       "operator": "ExternalTaskSensor",
//       "max_tries": 1,
//       "pool": "default_pool",
//       "queue": "default",
//       "hostname": "qualdo-airflow.ci4cw2o2wwoehdvop01k2t0hxg.xx.internal.cloudapp.net",
//       "external_dag_id": "raw_data_ingestion_dag",
//       "external_task_id": null
//     }
//   }
// }
 return handleApiCall("GET", "lineage_stage_metadata", requestParams);
}


export function pipelineDetailsDatasetInfo(requestParams){
 // requestParams =  {"tenant_id": 1, "p_integration_id": 6, "pipeline_id": 35, "lineage_data_id": "153"}
//   return {
//   "code": 200,
//   "message": "Successfully fetched",
//   "data": {
//     "stage_data": {
//       "stage_id": 13487,
//       "stage_name": "wait_for_ingestion_pipeline",
//       "dag_id": "data_transformation_pipeline",
//       "operator": "ExternalTaskSensor",
//       "max_tries": 1,
//       "pool": "default_pool",
//       "queue": "default",
//       "hostname": "qualdo-airflow.ci4cw2o2wwoehdvop01k2t0hxg.xx.internal.cloudapp.net",
//       "external_dag_id": "raw_data_ingestion_dag",
//       "external_task_id": null
//     }
//   }
// }
 return handleApiCall("GET", "lineage_dataset_metadata", requestParams);
}

export function pipelineTroubleShootStagesInfo(requestParams){

//     return {
//   "code": 200,
//   "message": "Successfully fetched",
//   "data": {
//     "stage_data": {
//       "stage_id": 13487,
//       "stage_name": "wait_for_ingestion_pipeline",
//       "stage_start_time": "2026-01-10T19:36:19Z",
//       "stage_status_code": 1,
//       "stage_status_text": "Succeeded",
//       "duration": 466,
//       "activity_output": "qualdo-airflow.ci4cw2o2wwoehdvop01k2t0hxg.xx.internal.cloudapp.net\n INFO - ::group::Log message source details\n*** Found local files:\n***   * /home/airflowdl/airflow/logs/dag_id=data_transformation_pipeline/run_id=scheduled__2026-01-10T19:00:00+00:00/task_id=wait_for_ingestion_pipeline/attempt=1.log\n INFO - ::endgroup::\n[2026-01-10T19:36:19.483+0000] {local_task_job_runner.py:123} INFO - ::group::Pre task execution logs\n[2026-01-10T19:36:19.498+0000] {taskinstance.py:2613} INFO - Dependencies all met for dep_context=non-requeueable deps ti=<TaskInstance: data_transformation_pipeline.wait_for_ingestion_pipeline scheduled__2026-01-10T19:00:00+00:00 [queued]>\n[2026-01-10T19:36:19.507+0000] {taskinstance.py:2613} INFO - Dependencies all met for dep_context=requeueable deps ti=<TaskInstance: data_transformation_pipeline.wait_for_ingestion_pipeline scheduled__2026-01-10T19:00:00+00:00 [queued]>\n[2026-01-10T19:36:19.507+0000] {taskinstance.py:2866} INFO - Starting attempt 1 of 2\n[2026-01-10T19:36:19.538+0000] {taskinstance.py:2889} INFO - Executing <Task(ExternalTaskSensor): wait_for_ingestion_pipeline> on 2026-01-10 19:00:00+00:00\n[2026-01-10T19:36:19.542+0000] {standard_task_runner.py:72} INFO - Started process 5564 to run task\n[2026-01-10T19:36:19.547+0000] {standard_task_runner.py:104} INFO - Running: ['airflow', 'tasks', 'run', 'data_transformation_pipeline', 'wait_for_ingestion_pipeline', 'scheduled__2026-01-10T19:00:00+00:00', '--job-id', '56299', '--raw', '--subdir', 'DAGS_FOLDER/data_transformation_pipeline.py', '--cfg-path', '/tmp/tmpeuatm_ao']\n[2026-01-10T19:36:19.548+0000] {standard_task_runner.py:105} INFO - Job 56299: Subtask wait_for_ingestion_pipeline\n[2026-01-10T19:36:19.605+0000] {task_command.py:467} INFO - Running <TaskInstance: data_transformation_pipeline.wait_for_ingestion_pipeline scheduled__2026-01-10T19:00:00+00:00 [running]> on host qualdo-airflow.ci4cw2o2wwoehdvop01k2t0hxg.xx.internal.cloudapp.net\n[2026-01-10T19:36:19.945+0000] {taskinstance.py:3132} INFO - Exporting env vars: AIRFLOW_CTX_DAG_OWNER='airflow' AIRFLOW_CTX_DAG_ID='data_transformation_pipeline' AIRFLOW_CTX_TASK_ID='wait_for_ingestion_pipeline' AIRFLOW_CTX_EXECUTION_DATE='2026-01-10T19:00:00+00:00' AIRFLOW_CTX_TRY_NUMBER='1' AIRFLOW_CTX_DAG_RUN_ID='scheduled__2026-01-10T19:00:00+00:00'\n[2026-01-10T19:36:19.946+0000] {logging_mixin.py:190} INFO - Task instance is in running state\n[2026-01-10T19:36:19.946+0000] {logging_mixin.py:190} INFO -  Previous state of the Task instance: queued\n[2026-01-10T19:36:19.946+0000] {logging_mixin.py:190} INFO - Current task name:wait_for_ingestion_pipeline state:running start_date:2026-01-10 19:36:19.498442+00:00\n[2026-01-10T19:36:19.946+0000] {logging_mixin.py:190} INFO - Dag name:data_transformation_pipeline and current dag run status:running\n[2026-01-10T19:36:19.947+0000] {taskinstance.py:731} INFO - ::endgroup::\n[2026-01-10T19:36:19.947+0000] {baseoperator.py:421} WARNING - ExternalTaskSensor.execute cannot be called outside TaskInstance!\n[2026-01-10T19:36:19.951+0000] {external_task.py:274} INFO - Poking for DAG 'raw_data_ingestion_dag' on 2026-01-10T19:00:00+00:00 ... \n[2026-01-10T19:36:19.956+0000] {logging_mixin.py:190} WARNING - /home/airflowdl/airflow_venv/lib/python3.8/site-packages/airflow/utils/session.py:97 DeprecationWarning: This method is deprecated and will be removed in future.\n[2026-01-10T19:36:19.960+0000] {base.py:336} INFO - Success criteria met. Exiting.\n[2026-01-10T19:36:19.964+0000] {taskinstance.py:340} INFO - ::group::Post task execution logs\n[2026-01-10T19:36:19.964+0000] {taskinstance.py:352} INFO - Marking task as SUCCESS. dag_id=data_transformation_pipeline, task_id=wait_for_ingestion_pipeline, run_id=scheduled__2026-01-10T19:00:00+00:00, execution_date=20260110T190000, start_date=20260110T193619, end_date=20260110T193619\n[2026-01-10T19:36:19.993+0000] {logging_mixin.py:190} INFO - Task instance in success state\n[2026-01-10T19:36:19.994+0000] {logging_mixin.py:190} INFO -  Previous state of the Task instance: running\n[2026-01-10T19:36:19.994+0000] {logging_mixin.py:190} INFO - Dag name:data_transformation_pipeline queued_at:2026-01-10 19:34:47.228695+00:00\n[2026-01-10T19:36:19.994+0000] {logging_mixin.py:190} INFO - Task hostname:qualdo-airflow.ci4cw2o2wwoehdvop01k2t0hxg.xx.internal.cloudapp.net operator:ExternalTaskSensor\n[2026-01-10T19:36:20.004+0000] {local_task_job_runner.py:266} INFO - Task exited with return code 0\n[2026-01-10T19:36:20.032+0000] {taskinstance.py:3895} INFO - 1 downstream tasks scheduled from follow-on schedule check\n[2026-01-10T19:36:20.056+0000] {local_task_job_runner.py:245} INFO - ::endgroup::\n",
//       "error_message": null,
//       "stage_end_time": "2026-01-10T19:36:19Z"
//     }
//   }
// }

 return handleApiCall("GET", "lineage_stage_metadata", requestParams);

}



